module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BoldSemiExtIt.383adbc.ttf";